/**
 * @copyright Copyright (c) 2019 Julius Härtl <jus@bitgrid.net>
 *
 * @author Julius Härtl <jus@bitgrid.net>
 *
 * @license GNU AGPL version 3 or any later version
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as
 * published by the Free Software Foundation, either version 3 of the
 * License, or (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program. If not, see <http://www.gnu.org/licenses/>.
 *
 */

import { getCurrentUser } from '@nextcloud/auth'
import getLoggedInUser from '../helpers/getLoggedInUser.js'

const cookieAlreadySet = (cookieName) => {
	return document.cookie
		.split(';')
		.some(cookie => {
			return cookie.trim().startsWith(`${cookieName}=`)
		})
}

const setGuestNameCookie = (username) => {
	if (username !== '') {
		document.cookie = 'guestUser=' + encodeURIComponent(username) + '; path=/'
	}
}

const shouldAskForGuestName = () => {
	const noLoggedInUser = !getLoggedInUser()
	const noGuestCookie = !cookieAlreadySet('guestUser')
	const noCurrentUser = !getCurrentUser() || getCurrentUser()?.uid === ''

	return noLoggedInUser && noGuestCookie && noCurrentUser
}

export {
	setGuestNameCookie,
	shouldAskForGuestName,
}
